module.exports = __webpack_public_path__ + "images/category_lp/common/icon-cheapest-price@2x_2178d3ade342dd67613902d1015bbaf5.png";